import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined"
import PendingActionsIcon from "@mui/icons-material/PendingActions"
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined"
import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined"
// import DownloadingIcon from '@mui/icons-material/Downloading'
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined"

export const config = [
  {
    title: "Habilitación en proceso. Delegación en espera",
    code: "WAITING-DELEGATION",
    icon: (
      <PendingActionsIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
    dependences: [
      // "DELEGATION-MISSING", "DELEGATION-ACCEPTED"
    ],
  },
  {
    title: "Habilitación en proceso. Delegación aceptada",
    code: "DELEGATION-ACCEPTED",
    icon: (
      <AssignmentTurnedInOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
    dependences: [
      // "WAITING-DELEGATION",
      // "DELEGATION-MISSING",
      "ACTIVE-LOAD-FAIL-NO-AUTH",
    ],
  },
  {
    title: "Habilitación en proceso. Delegación aún no registrada",
    code: "DELEGATION-MISSING",
    icon: (
      <AssignmentLateOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
    dependences: [
      "WAITING-DELEGATION",
      // "DELEGATION-ACCEPTED"
    ],
  },
  // {
  //   title: "Servicio no activo: Baja delegación en proceso",
  //   code: "DELEGATION-CANCEL-IN-PROGRESS",
  //   icon: (
  //     <DownloadingIcon
  //       style={{
  //         cursor: "pointer",
  //       }}
  //     />
  //   ),
  //   dependences: [],
  // },
  {
    title: "Servicio no activo: Deshabilitación",
    code: "DISABLED",
    icon: (
      <UnsubscribeOutlinedIcon
        style={{
          cursor: "pointer",
        }}
      />
    ),
    dependences: ["DELEGATION-CANCEL-IN-PROGRESS"],
  },
  {
    title: "Ver detalles",
    code: "INFORMATION",
    icon: (
      <ErrorOutlineOutlinedIcon
        style={{
          cursor: "pointer",
          transform: "rotate(180deg)",
        }}
      />
    ),
    dependences: [],
  },
]
